import React, { useEffect, useRef, useState } from 'react';
import './Stats.css';

const stats = [
  { target: 12000, suffix: '+',     label: 'Properties Listed', duration: 2200, prefix: '' },
  { target: 8500,  suffix: '+',     label: 'Happy Clients',     duration: 2000, prefix: '' },
  { target: 320,   suffix: '+',     label: 'Expert Agents',     duration: 1600, prefix: '' },
  { target: 15,    suffix: '+ Yrs', label: 'Years Experience',  duration: 1200, prefix: '' },
];

/* Comma-format: 12000 → 12,000 */
function fmt(n) { return n.toLocaleString('en-IN'); }

/* Eased count-up animation */
function CountUp({ target, duration, started, prefix, suffix }) {
  const [count, setCount] = useState(0);
  const raf = useRef(null);

  useEffect(() => {
    if (!started) return;
    let t0 = null;
    const tick = (ts) => {
      if (!t0) t0 = ts;
      const progress = Math.min((ts - t0) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // easeOutCubic
      setCount(Math.floor(eased * target));
      if (progress < 1) raf.current = requestAnimationFrame(tick);
      else setCount(target);
    };
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
  }, [started, target, duration]);

  return (
    <span className="stat-count-inner">
      {prefix}{fmt(count)}<span className="stat-suffix">{suffix}</span>
    </span>
  );
}

export default function Stats() {
  const [started, setStarted] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setStarted(true); obs.disconnect(); } },
      { threshold: 0.25 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="stats" ref={ref}>
      {/* subtle top glow line */}
      <div className="stats-glow-line" />

      <div className="stats-container">
        {stats.map((s, i) => (
          <React.Fragment key={i}>
            <div className={`stat-item ${started ? 'stat-visible' : ''}`}
                 style={{ animationDelay: `${i * 0.12}s` }}>
              <div className="stat-number">
                <CountUp
                  target={s.target}
                  duration={s.duration}
                  started={started}
                  prefix={s.prefix}
                  suffix={s.suffix}
                />
              </div>
              <div className="stat-label">{s.label}</div>
            </div>
            {/* divider between items (not after last) */}
            {i < stats.length - 1 && <div className="stat-divider" />}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}
